<template>
  <div>
    <v-dialog :value="isActive" persistent max-width="1000" scrollable>
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Detalles
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Nombre -->
              <v-col cols="12" class="pb-0">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      Tiempo de cierre (En segundos)
                    </v-list-item-subtitle>
                    <div>
                      {{
                        data.closing_time_sg != null
                          ? data.closing_time_sg
                          : "(No posee)"
                      }}
                    </div>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Mensaje inicial</v-list-item-subtitle>
                    <div>{{ data.initial_message }}</div>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Mensaje de despedida</v-list-item-subtitle
                    >
                    <div>{{ data.goodbye_message }}</div>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >Mensaje de retorno</v-list-item-subtitle
                    >
                    <div>{{ data.return_message }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12">
                <!-- Opciones -->
                <VTreeCrudList
                  title="Lista de opciones"
                  :data="optionsList"
                  :loadChildren="getChildren"
                  @item:createChild="openCreateNewItem"
                  @item:edit="openEditItem"
                  @item:delete="handleDelete"
                  keyToDisabledAdd="is_sub_menu"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <new-form-options
      v-if="isOpenFormOptions"
      :isActive="isOpenFormOptions"
      :parentId="selectedItem.id"
      :dataToEdit="selectedOptionToEdit"
      @close:dialog="closeFormDialog"
    ></new-form-options>

    <!-- Used to add new bots -->
    <newForm
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :dataToEdit="eventToEdit"
      :parentId="selectedItem.id"
      :whatsappId="data.whatsapp_id"
      @close:dialog="closeFormDialog"
    ></newForm>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
import newForm from "./VTreeCrud/newForm.vue";
import NewFormOptions from "./newFormOptions.vue";
import { PbxHttpClient } from "@/services/httpclient";
import VTreeCrudList from "@/components/Utils/VTreeCrud/VTreeCrudDialog.vue";
import {
  generateTreeData,
  modifyData,
} from "@/components/Utils/VTreeCrud/utils";

/**
 * submenu
 */
export default {
  components: {
    vuescroll,
    newForm,
    NewFormOptions,
    VTreeCrudList,
  },
  props: {
    isActive: {
      type: Boolean,
    },
    isOptionEditMode: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      // Options
      isOpenFormOptions: false,
      selectedOptionToEdit: {},
      // Bot
      isOpenForm: false,
      eventToEdit: {},
      selectedItem: {},
      optionsList: generateTreeData(this.data.options),
      isLoading: false,
      showChildreInfo: {},
      payload: {
        name: "",
        menu_message: "",
        return_message: "",
        initial_message: "",
        closing_time_sg: null,
        goodbye_message: "",
        closing_queue: null,
        use: null,
      },
      headers: [
        {
          text: "Opción",
          align: "left",
          value: "option",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Mensaje",
          align: "left",
          value: "message",
          class: "primary--text",
          width: "50%",
          sortable: false,
        },
        {
          text: "Redirección",
          align: "left",
          value: "redirection",
          class: "primary--text",
          width: "10%",
          sortable: false,
        },
        {
          text: "Hijos",
          align: "left",
          value: "children",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  mounted() {
    this.getSelectsInfo();
  },
  methods: {
    openCreateNewItem(item) {
      this.selectedItem = item;
      if (item.is_sub_menu) this.isOpenFormOptions = true;
      else this.isOpenForm = true;
    },
    openEditItem(item) {
      const isOption = !item.is_sub_menu;
      if (isOption) {
        this.selectedOptionToEdit = item;
        this.isOpenFormOptions = true;
      } else {
        this.eventToEdit = item;
        this.isOpenForm = true;
      }
    },

    closeEditDialog(data) {
      const isOption = !!data.bot_id;
      const children = isOption
        ? this.selectedOptionToEdit.children || []
        : this.eventToEdit.children || [];
      const parentId = isOption ? data.bot_id : data.option_id;
      const isMainParent = this.selectedOptionToEdit.isMainParent;
      const dataWithChildren = {
        ...data,
        message: data.message || data.menu_message,
        children,
        isMainParent,
      };

      this.optionsList = modifyData(
        [...this.optionsList],
        dataWithChildren,
        parentId,
        isMainParent
      );
      this.eventToEdit = {};
      this.isOpenForm = false;
      this.selectedOptionToEdit = {};
      this.isOpenFormOptions = false;
    },

    closeFormDialog(data = false, isEdit = false) {
      console.log("Data from create", data);
      if (isEdit) {
        console.log("isEdit");
        this.closeEditDialog(data);
        return;
      }
      const isOption = !!data.bot_id;

      if (data) {
        const parentId = isOption ? data.bot_id : data.option_id;
        const dataWithChildren = {
          ...data,
          message: data.message || data.menu_message,
          children: [],
        };

        this.optionsList = modifyData(
          [...this.optionsList],
          dataWithChildren,
          parentId
        );
      }
      this.eventToEdit = {};
      this.isOpenForm = false;
      this.selectedOptionToEdit = {};
      this.isOpenFormOptions = false;
    },
    async getChildren(item) {
      this.isLoading = true;
      const isOption = !item.is_sub_menu;
      const data = isOption
        ? await this.getBotFromOption(item)
        : await this.getOptions(item);
      if (data.length) {
        const itemWithChildren = { ...item, children: data };
        const parentId = isOption ? item.bot_id : item.option_id;
        this.optionsList = modifyData(
          [...this.optionsList],
          itemWithChildren,
          parentId
        );
      }
      this.isLoading = false;
      this.activeVTreeCrud = true;
    },

    async getOptions(item) {
      try {
        const { data } = await PbxHttpClient.get(
          `/whatsapps/options_bot/${item.id}`
        );
        return data.map((el) => ({ ...el, children: [] }));
      } catch (error) {
        console.error(error);
        this.$snotify.error(
          "Hubo un error al obtener la información.",
          "Error"
        );
      }
    },
    async getBotFromOption(item) {
      try {
        const { data } = await PbxHttpClient.get(`/whatsapps/bot/${item.id}`);
        return [data];
      } catch (error) {
        console.error(error);
        this.$snotify.error(
          "Hubo un error al obtener la información.",
          "Error"
        );
      }
    },
    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },
    async getSelectsInfo() {
      let endpoints = [`/whatsapps/options_bot/${this.data.id}`];
      try {
        const responses = await Promise.all(
          endpoints.map((endpoint) => PbxHttpClient.get(endpoint))
        );
        this.optionsList = generateTreeData(responses[0].data);
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta.", "Error");
      }
    },
    async submitForm() {
      this.isLoading = true;
      const { id, ...payload } = this.payload;
      payload.whatsapp_id = this.whatsappId;
      payload.option_id = this.parentId;
      payload.use = false;
      const url = this.isEditMode ? `/whatsapps/bot/${id}` : "/whatsapps/bot";
      const method = this.isEditMode ? "put" : "post";
      try {
        const { data } = await PbxHttpClient[method](url, payload);
        this.closeDialog(data.bot);
        this.$snotify.success(
          `Bot ${this.isEditMode ? "actualizado" : "creado"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },

    async handleDelete(event) {
      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          await PbxHttpClient.delete(`/whatsapps/options_bot/${event.id}`);
          this.optionsList = this.optionsList.filter(
            (el) => el.id !== event.id
          );
          this.$snotify.success("Opción eliminada", "¡Hecho!");
        }
      } catch (error) {
        console.log(error);
        this.$snotify.error("No se pudo eliminar.", "¡Error!");
      }
    },
  },
};
</script>
